// extracted by mini-css-extract-plugin
module.exports = {"siteFooter":"SiteFooter__siteFooter__1YyJe","copyright":"SiteFooter__copyright__3QVTp","flair":"SiteFooter__flair__1r_Gv","container":"SiteFooter__container__2H7p5"};